<div class="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
     (click)="onCancel()">
  <div class="bg-white dark:bg-app-black-500 rounded shadow-lg w-[640px] max-w-[95vw] max-h-[90vh] overflow-y-auto border border-gray-200 dark:border-[#434863]"
       (click)="$event.stopPropagation()">
    <div class="py-3 px-6 dark:bg-app-black-100 rounded-t flex items-start justify-between gap-3">
      <div class="min-w-0">
        <h1 class="text-md font-semibold leading-tight tracking-tight text-gray-900 md:text-xl dark:text-white">
          <i class="fa-solid fa-tower-broadcast text-app-teal-100 mr-2"></i> {{ title }}
        </h1>
        <div *ngIf="userDisplayName || userEmail" class="mt-1 leading-tight">
          <div *ngIf="userDisplayName" class="text-sm font-medium text-gray-800 dark:text-gray-100">
            {{ userDisplayName }}
          </div>
          <div *ngIf="userEmail" class="text-xs text-gray-500 dark:text-gray-400">
            {{ userEmail }}
          </div>
        </div>
      </div>
      <button type="button" (click)="openDebugModal()"
              title="Debug: raw state as JSON"
              class="flex-shrink-0 inline-flex items-center gap-1 text-[10px] uppercase tracking-wide text-gray-500 hover:text-app-teal-100 border border-gray-300 dark:border-[#434863] hover:border-app-teal-100 rounded px-2 py-1">
        <i class="fa-solid fa-code"></i>
        Debug JSON
      </button>
    </div>

    <div class="py-4 px-6 dark:bg-gradient-to-b dark:from-app-black-200 dark:to-app-black-300 text-sm">
      <p *ngIf="cards.length === 0 && orphans.length === 0"
         class="mb-4 text-xs text-gray-500 dark:text-gray-400">
        This user isn't entitled to any scanner that defines a channels list.
        Assign scanners via the Scanners dialog first, or add a channels[]
        array on the Scanner doc.
      </p>

      <!-- Outer box: one per customer; inside, one card per scanner. -->
      <div *ngFor="let group of cardGroups"
           class="mb-4 border border-gray-300 dark:border-[#434863] rounded-md bg-gray-50/40 dark:bg-app-black-200/40">
        <div class="px-3 py-2 border-b border-gray-200 dark:border-[#434863] flex items-center gap-2">
          <i class="fa-solid fa-building text-app-teal-100 text-xs"></i>
          <span class="text-xs font-semibold text-gray-800 dark:text-gray-100">
            {{ group.customer.name || group.customer._id }}
          </span>
          <span class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">
            {{ group.customer._id }}
          </span>
          <span class="ml-auto text-[10px] uppercase tracking-wide text-gray-400">
            {{ group.cards.length }} scanner{{ group.cards.length === 1 ? '' : 's' }}
          </span>
        </div>
        <div class="p-3 flex flex-col gap-2">

          <div *ngFor="let card of group.cards"
               class="border border-gray-300 dark:border-app-black-100 rounded bg-white dark:bg-app-black-100">
            <div class="flex items-center justify-between px-3 py-2 cursor-pointer select-none"
                 (click)="toggleExpanded(card)">
              <div class="flex flex-col min-w-0">
                <span class="text-sm font-medium truncate text-gray-900 dark:text-white">
                  {{ card.scannerName || card.scannerId }}
                </span>
                <span class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400 truncate">
                  {{ cardSubtitle(card) }}
                </span>
              </div>
              <div class="flex items-center gap-2 flex-shrink-0">
                <span *ngIf="cardHasRoleEdits(card)"
                      class="text-[9px] uppercase tracking-wide text-amber-500 border border-amber-500/60 rounded px-1.5 py-0.5"
                      title="Role visibility edits on this scanner — scanner doc will be PATCHed on Save.">
                  Role edits
                </span>
                <span class="text-[11px] text-gray-500 dark:text-gray-400">
                  {{ cardSummary(card) }}
                </span>
                <i class="fa-solid text-xs text-gray-500 dark:text-gray-400"
                   [class.fa-chevron-down]="card.expanded"
                   [class.fa-chevron-right]="!card.expanded"></i>
              </div>
            </div>

            <div *ngIf="card.expanded" class="px-3 pb-3 border-t border-gray-200 dark:border-app-black-100">
              <div class="mt-3 flex items-center justify-end gap-2 mb-2">
                <button type="button" (click)="selectAll(card)"
                        class="text-[10px] uppercase tracking-wide text-app-teal-100 hover:text-app-teal-200">
                  Select all
                </button>
                <span class="text-[10px] text-gray-400">·</span>
                <button type="button" (click)="clearAll(card)"
                        class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400 hover:text-gray-300">
                  Clear
                </button>
              </div>
              <!-- IT-F2-406 cid df79e959 — editing a channel id orphans
                   existing user subscriptions (every user's custom:notify_channels
                   CSV references the OLD id). Only rename when you're OK
                   with that; otherwise edit title/slug only. -->
              <p *ngIf="card.metadataDirty"
                 class="mb-2 text-[10px] text-amber-500 flex items-start gap-1">
                <i class="fa-solid fa-triangle-exclamation mt-0.5 flex-shrink-0"></i>
                <span>Editing a channel <strong>id</strong> orphans every user's existing subscription for the old id. Edit title/slug freely; rename ids only when you intend the break.</span>
              </p>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
                <div *ngFor="let ch of card.channels"
                     class="text-xs text-gray-900 dark:text-white border border-gray-200 dark:border-[#434863] rounded px-2 py-1.5 hover:border-app-teal-100">
                  <!-- IT-F2-406 cid df79e959 — title / id / slug inline-editable.
                       Each ngModelChange flips card.metadataDirty so the Save path
                       emits a scannersService.updateScanner PATCH for this card. -->
                  <div class="flex items-start gap-2 w-full">
                    <input type="checkbox"
                           [checked]="isChannelSelected(card, ch.id)"
                           (change)="toggleChannel(card, ch.id)"
                           class="mt-1.5 cursor-pointer flex-shrink-0" />
                    <div class="flex flex-col min-w-0 flex-1 gap-1">
                      <input type="text"
                             [(ngModel)]="ch.title"
                             (ngModelChange)="markMetadataDirty(card)"
                             placeholder="title"
                             class="w-full bg-transparent border border-transparent hover:border-gray-300 dark:hover:border-[#434863] focus:border-app-teal-100 focus:outline-none rounded px-1 py-0.5 text-xs font-medium text-gray-900 dark:text-white" />
                      <div class="flex items-center gap-1">
                        <input type="text"
                               [(ngModel)]="ch.id"
                               (ngModelChange)="markMetadataDirty(card)"
                               placeholder="id"
                               class="flex-1 min-w-0 bg-transparent border border-transparent hover:border-gray-300 dark:hover:border-[#434863] focus:border-app-teal-100 focus:outline-none rounded px-1 py-0.5 text-[10px] font-mono uppercase tracking-wide text-gray-500 dark:text-gray-400" />
                        <span class="text-[10px] text-gray-500 dark:text-gray-500">•</span>
                        <input type="text"
                               [(ngModel)]="ch.slug"
                               (ngModelChange)="markMetadataDirty(card)"
                               placeholder="slug"
                               class="flex-1 min-w-0 bg-transparent border border-transparent hover:border-gray-300 dark:hover:border-[#434863] focus:border-app-teal-100 focus:outline-none rounded px-1 py-0.5 text-[10px] font-mono uppercase tracking-wide text-gray-500 dark:text-gray-400" />
                      </div>
                    </div>
                  </div>
                  <!-- IT-F2-406 cid d97cf968 — role-visibility chips.
                       Writes to Scanners.<id>.channels[].visible_to_roles.
                       Empty picks = visible to all entitled (default). -->
                  <div class="mt-2 flex items-center gap-1.5 flex-wrap"
                       [title]="'Role visibility — leave empty to show to all entitled users; non-empty = user.custom:role must match. admins bypass.'">
                    <span class="text-[9px] uppercase tracking-wide text-gray-500 dark:text-gray-500">Roles:</span>
                    <button *ngFor="let role of ROLE_OPTIONS"
                            type="button"
                            (click)="toggleChannelRole(card, ch, role)"
                            class="text-[9px] uppercase tracking-wide font-mono border rounded px-1.5 py-0.5 transition-colors"
                            [ngClass]="isChannelRoleSelected(card, ch, role)
                              ? 'bg-app-teal-100/20 border-app-teal-100 text-app-teal-100'
                              : 'border-gray-300 dark:border-[#434863] text-gray-500 dark:text-gray-500 hover:border-app-teal-100 hover:text-app-teal-100'">
                      {{ ROLE_LABELS[role] }}
                    </button>
                    <span *ngIf="channelHasRoleOverride(card, ch)"
                          class="text-[9px] text-amber-500 ml-auto"
                          title="Role list changed from server value — will save on Save.">
                      <i class="fa-solid fa-circle-exclamation"></i> dirty
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Orphan channel ids: present in the CSV but not declared on
           any entitled scanner. Click × to drop; otherwise they
           round-trip on save. -->
      <div *ngIf="orphans.length" class="mt-3">
        <h3 class="text-xs uppercase tracking-wide text-amber-500 mb-2 flex items-center gap-2">
          <i class="fa-solid fa-triangle-exclamation"></i>
          Other channels
          <span class="text-[10px] normal-case text-gray-500 dark:text-gray-400">
            (not declared on any of this user's scanners)
          </span>
        </h3>
        <div class="flex flex-wrap gap-2">
          <span *ngFor="let id of orphans"
                class="inline-flex items-center gap-1 text-xs bg-amber-500/10 border border-amber-500/40 text-amber-700 dark:text-amber-300 rounded px-2 py-0.5">
            {{ id }}
            <button type="button" (click)="removeOrphan(id)"
                    class="text-amber-500 hover:text-amber-400" aria-label="Remove">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="mt-6 flex gap-2 justify-end">
        <button type="button" (click)="onCancel()" class="dark-btn-secondary text-xs px-3 py-1">cancel</button>
        <button type="button" (click)="onSave()" class="dark-btn-primary text-xs px-3 py-1">save</button>
      </div>
    </div>
  </div>
</div>

<!-- Debug JSON modal — surfaces raw state for diagnosing pool-mismatch /
     missing-grant / stale-cache cases without DevTools. IT-F2-406 cid 713e99c2.
     Rendered as a sibling of the main overlay so backdrop clicks don't bubble
     into the parent cancel handler. -->
<div *ngIf="showDebugModal"
     class="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4"
     (click)="closeDebugModal()">
  <div class="bg-white dark:bg-app-black-500 rounded shadow-lg w-[820px] max-w-[95vw] max-h-[90vh] flex flex-col border border-gray-200 dark:border-[#434863]"
       (click)="$event.stopPropagation()">
    <div class="py-3 px-6 dark:bg-app-black-100 rounded-t flex items-center justify-between gap-3">
      <h2 class="text-sm font-semibold text-gray-900 dark:text-white">
        <i class="fa-solid fa-code text-app-teal-100 mr-2"></i>
        Channels Editor — Debug JSON
      </h2>
      <div class="flex items-center gap-2">
        <button type="button" (click)="copyDebugJson()"
                class="text-[10px] uppercase tracking-wide inline-flex items-center gap-1 border rounded px-2 py-1"
                [ngClass]="debugCopied
                  ? 'text-emerald-500 border-emerald-500'
                  : 'text-gray-500 border-gray-300 dark:border-[#434863] hover:text-app-teal-100 hover:border-app-teal-100'">
          <i class="fa-solid" [ngClass]="debugCopied ? 'fa-check' : 'fa-copy'"></i>
          {{ debugCopied ? 'Copied' : 'Copy' }}
        </button>
        <button type="button" (click)="closeDebugModal()"
                class="text-gray-500 hover:text-gray-300 text-sm" aria-label="Close">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
    <pre class="flex-1 overflow-auto text-[11px] leading-snug px-6 py-4 text-gray-800 dark:text-gray-100 font-mono whitespace-pre bg-gray-50 dark:bg-app-black-300">{{ debugJson }}</pre>
  </div>
</div>
